module.exports = __webpack_public_path__ + "img/lazy-data-loading.png";